module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1BErz"))).then(() => parcelRequire('dJXJK'));